/** Small frontend helpers. */

const EXT_BY_TYPE = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "image/gif": "gif",
  "image/avif": "avif",
  "image/svg+xml": "svg",
};

/** Best-guess image extension for a File (from its name, else its MIME type). */
export function fileExt(file) {
  const fromName = (file.name.match(/\.([a-z0-9]+)$/i) || [])[1];
  if(fromName) return fromName.toLowerCase().replace("jpeg", "jpg");
  return EXT_BY_TYPE[file.type] || "jpg";
}

/** Copy text to the clipboard, returning true on success. */
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback for non-secure contexts.
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand("copy"); } catch { /* ignore */ }
    ta.remove();
    return ok;
  }
}
